import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../../components/Common/TableContainer"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import DeleteModal from "../../../components/Common/DeleteModal"

import { getMDMParrainage, updateMDMParrainage } from "store/actions"

//redux
import { useSelector, useDispatch } from "react-redux"

import { Col, Row, UncontrolledTooltip, Card, CardBody } from "reactstrap"
import { withTranslation } from "react-i18next"
import ParrainageTypeModal from "./ParrainageTypeModal"
import { checkPermission } from "helpers/functions"

function ParrainageType(props) {
  //meta title
  document.title = "Mazaya"

  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [parrainage, setPayment] = useState(null)
  const [show, setShow] = useState(false)
  const [filter, setFilter] = useState({
    page: 1,
    limit: 100,
    status: "active",
  })

  const dispatch = useDispatch()

  const {
    parrainageData,
    error,
    success,
    nextPage,
    currentPage,
    previousPage,
    total,
    limit,
    loading,
  } = useSelector(state => state.parrainageTypes)
  const userRoles = useSelector(state => state.Login.user?.roles)

  useEffect(() => {
    dispatch(getMDMParrainage(filter))
  }, [dispatch, filter])

  useEffect(() => {
    if (!isEmpty(parrainageData) && !!isEdit) {
      setIsEdit(false)
    }
  }, [parrainageData])

  const toggle = () => {
    if (modal) {
      setModal(false)
      setPayment(null)
    } else {
      setModal(true)
    }
  }

  const toggleShow = () => {
    setShow(!show)
  }

  const handleOrderClick = arg => {
    const parrainage = arg
    setPayment({
      ...parrainage,
    })

    setIsEdit(true)

    toggle()
  }

  //delete order
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = parrainage => {
    setPayment(parrainage)
    setDeleteModal(true)
  }

  const handleDeleteLevel = () => {
    if (parrainage.id) {
      dispatch(updateMDMParrainage({ id: parrainage.id, status: "archived" }))
      setDeleteModal(false)
      dispatch(getMDMParrainage(filter))
    }
  }
  const handleOrderClicks = () => {
    setIsEdit(false)
    toggle()
  }

  const columns = useMemo(
    () => [
      {
        Header: props.t("English Name"),
        accessor: "nameEn",
        disableFilters: true,
        accessor: cellProps => {
          return (
            <div
              className="external-event"
              onClick={() => {
                setPayment(cellProps)
                toggleShow()
              }}
            >
              {cellProps.nameEn}
            </div>
          )
        },
      },
      {
        Header: props.t("N. of Accounts"),
        accessor: "value",
        disableFilters: true,
        accessor: cellProps => {
          return <>{cellProps.value || 0}</>
        },
      },
      {
        Header: props.t("Status"),
        accessor: "status",
        disableFilters: true,
        accessor: cellProps => {
          return <>{props.t(cellProps.status)}</>
        },
      },

      {
        Header: props.t("Action"),
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="text-center">
              {checkPermission(userRoles, [
                "MasterData",
                "ParrainageType",
                "Update",
              ]) && (
                <Link
                  to="#"
                  className="text-tip"
                  onClick={() => {
                    const orderData = cellProps.row.original
                    handleOrderClick(orderData)
                  }}
                >
                  <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    {props.t("Edit")}
                  </UncontrolledTooltip>
                </Link>
              )}
              {checkPermission(userRoles, [
                "MasterData",
                "ParrainageType",
                "Delete",
              ]) && (
                <Link
                  to="#"
                  className="text-danger"
                  onClick={() => {
                    const orderData = cellProps.row.original
                    onClickDelete(orderData)
                  }}
                >
                  <i
                    className="mdi mdi-delete font-size-18"
                    id="deletetooltip"
                  />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    {props.t("Delete")}
                  </UncontrolledTooltip>
                </Link>
              )}
            </div>
          )
        },
      },
    ],
    []
  )

  const setPageNumber = activePage => {
    setFilter(prevFilter => {
      return { ...prevFilter, page: activePage }
    })
  }
  const handleLimit = limit => {
    setFilter(prevFilter => {
      return { ...prevFilter, limit: limit }
    })
  }

  return (
    <React.Fragment>
      <ParrainageTypeModal
        modal={modal}
        toggle={toggle}
        isEdit={isEdit}
        parrainage={parrainage}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteLevel}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs
            title={props.t("Parrainage Types")}
            breadcrumbItem={props.t("Parrainage Type List")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={parrainageData}
                    //isGlobalFilter={true}
                    isAddOptions={checkPermission(userRoles, [
                      "MasterData",
                      "ParrainageType",
                      "Create",
                    ])}
                    handleOrderClicks={handleOrderClicks}
                    customPageSize={100}
                    setPageNumber={setPageNumber}
                    currentPage={currentPage}
                    previousPage={previousPage}
                    nextPage={nextPage}
                    setLimit={handleLimit}
                    total={total}
                    limit={limit}
                    loading={loading}
                    success={success}
                    className="custom-header-css"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}
ParrainageType.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  t: PropTypes.any,
}

export default withTranslation()(ParrainageType)
